export type IHubAuthState = {
  _token: string
}

export const INITIAL_STATE: IHubAuthState = {
  _token: null
}
